import { createRouter, createWebHashHistory } from "vue-router";

import DashboardLayout from "@/layout/DashboardLayout";
import AuthLayout from "@/layout/AuthLayout";

import Dashboard from "@/views/Dashboard_copy.vue";
//import Icons from "@/views/Icons.vue";
//import Maps from "@/views/Maps.vue";
//import Profile from "@/views/UserProfile.vue";
import Account from "@/views/Account.vue"
import Modules from "@/views/Modules.vue";
import Terrains from "@/views/Terrains.vue";
import TerrainManager from "@/views/Terrains/TerrainManager.vue"
import Plots from "@/views/Plots.vue";
import PlotManager from "@/views/Plots/PlotManager.vue"
import Graphics from "@/views/Graphics.vue"


import Login from "@/views/Login/Login.vue";
import Register from "@/views/Register/Register.vue";
import VerifyAccount from "@/views/AccountManage/VerifyAccount.vue"
import PasswordRestore from "@/views/AccountManage/PasswordRestore.vue"

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    component: DashboardLayout,
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        components: { default: Dashboard },
      },
      {
        path: "/terrains",
        name: "terrains",
        components: { default: Terrains },
      },
      {
        path: "/terrains/manage",
        name: "terrain_manager",
        components: { default: TerrainManager },
      },      
      {
        path: "/modules",
        name: "modules",
        components: { default: Modules },
      },
      {
        path: "/plots",
        name: "plots",
        components: { default: Plots },
      },
      {
        path: "/plots/manage",
        name: "plot_manager",
        components: { default: PlotManager },
      }, 
      {
        path: "/account",
        name: "account",
        components: { default: Account },
      },
      {
        path: "/graphics",
        name: "graphics",
        components: { default: Graphics },
      },
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/",
    redirect: "login",
    component: AuthLayout,
    children: [
      {
        path: "/login",
        name: "login",
        components: { default: Login },
      },
      {
        path: "/register",
        name: "register",
        components: { default: Register },
      },
      {
        path: "/verify_account",
        name: "verify_account",
        components: {default: VerifyAccount}
      },
      {
        path: "/password_restore",
        name: "password_restore",
        components: {default: PasswordRestore}
      },
    ],
    meta: {
      guest: true
    }
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  linkActiveClass: "active",
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/register','/verify_account','/password_restore'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/login');
  } else {
    next();
  }
});

export default router;
